import React from "react";
import "./GridSquare.css";
import stack from "../../../src/icons/stack.svg";
import pin from "../../../src/icons/pin.png";
import { HashLink as Link } from "react-router-hash-link";
// import Image from '../Image/Image';
import { disableRightClick, compressedImage } from "../../utils";
import LazyLoad from "react-lazyload";

function GridSquare(props) {
  const { imgSrc, isMultiple, id, isPinned, reels } = props;

  return (
    <Link
      className="grid-item relative"
      to={reels === true ? `/reel/${id}` : `/post/${id}`}
    >
      <LazyLoad
        height={300} // Adjust this to match the height of your grid squares
        offset={100} // Load the image slightly before it scrolls into view
        placeholder={
          <div
            className={`bg-img w-full ${
              reels === true ? "rectangle" : "square"
            }`}
            style={{ backgroundColor: "#000000" }} // Placeholder background color
          />
        }
      >
        <div
          className={`image w-full ${reels === true ? "rectangle" : "square"}`}
        >
          {isMultiple && !isPinned && (
            <img
              src={stack}
              className="w-[18px] absolute m-[10px] right-0"
              alt=""
            />
          )}
          {isPinned && (
            <img
              src={pin}
              className="pin-icon w-[22px] absolute m-[10px] right-0"
              alt=""
            />
          )}
          <div
            style={{ backgroundImage: `url(${compressedImage(imgSrc)})` }}
            className={`bg-img w-full ${
              reels === true ? "rectangle" : "square"
            }`}
            onContextMenu={disableRightClick}
          />
          {/* <Image className={`image w-full ${(reels === true) ? "rectangle" : "square"}`} src={compressedImage(imgSrc)} /> */}
        </div>
      </LazyLoad>
    </Link>
  );
}

export default GridSquare;
